import React from 'react'
import propTypes from 'prop-types';
import './Buttons.css';

function MediumButton({ text, onClick, disabled, color, ...props }) {
  return (
        <button disabled={disabled} className={`medium-btn ${color || ''}`.trim()}
        onClick={onClick} {...props} >
            {text}
        </button>
  )
}

export default MediumButton

MediumButton.propTypes = {
    text: propTypes.string,
    onClick: propTypes.func,
    disabled: propTypes.bool,
    color: propTypes.string,
}